module.exports = __webpack_public_path__ + "static/media/circleminus.3dc02869.svg";